import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FreesSpinOutro} from "../runnerpresentations/FreesSpinOutro";
import {LocalPresentation} from "../runnerpresentations/LocalPresentation";
import {TheCage} from "../TheCage";
import {TheCageGameMode} from "../server/TheCageGameMode";
import {FreeSpinCollapsePresentation} from "../runnerpresentations/freespin/FreeSpinCollapsePresentation";
import {FreeSpinHitOpponentPresentation} from "../runnerpresentations/freespin/FreeSpinHitOpponentPresentation";
import {FreeSpinMultiplierFeature} from "../runnerpresentations/freespin/FreeSpinMultiplierFeature";
import {FreeSpinTransformFeature} from "../runnerpresentations/freespin/FreeSpinTransformFeature";
import {FreesSpinStickyWildFeature} from "../runnerpresentations/freespin/FreeSpinStickyWildFeature";
import {FreeSpinWinSummery} from "../runnerpresentations/freespin/FreeSpinWinSummery";
import {BrokeBankPresentation} from "../runnerpresentations/maingame/win/BrokeBankPresentation";
import {FreeSpinWin} from "../runnerpresentations/freespin/FreeSpinWin";


export class TheCageFreeSpinWinPresentation implements FlowStatePresentation {
    private presentations:SimplePresentation[];

    constructor() {
        this.presentations = [
            new FreesSpinStickyWildFeature(),
            new FreeSpinMultiplierFeature(),
            new FreeSpinTransformFeature(),
            new FreeSpinWin(),
            new LocalPresentation((controller:SimplePresentationRunnerController) => this.updateWin(controller), () => {return true}, "UpdateWin"),
            new FreeSpinCollapsePresentation(),
            new FreeSpinHitOpponentPresentation(),
            new BrokeBankPresentation(),
            new FreeSpinWinSummery(),
            new FreesSpinOutro(),
            //new FreeSpinSanityCheckPresentation(),
        ];
    }

    private updateWin(controller:SimplePresentationRunnerController) {
        //const useTotalWin = TheCage.model.gameData.accumulatedRoundWin != TheCage.model.gameData.totalSpinWinnings || TheCage.model.data.mode != TheCageGameMode.NORMAL;
        TheCage.keypadPlugin.setWin(TheCage.model.gameData.accumulatedRoundWin, true, TheCage.isWinBelowStake());
        controller.finish();
    }

    start(flowStateController:FlowStateController):void {
        SimplePresentationRunner.run(this.presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback), "TheCageFreeSpinResultPresentation");
    }
}